import { GoogleMapsPlaceURL, proxyurl } from '../constants/';
import HttpCalls from './api-call';

export const _getMaxReview = async (payload, cookies) => {
  let { _do_call } = HttpCalls;
  let headers = await headersData(cookies);
  return _do_call('GET', 'getInitialReview', headers, payload)
}

export const _getOTP = async (payload) => {
  let { _do_call } = HttpCalls;
  let headers = await headersData();
  return _do_call('POST', 'sendOTP', headers, payload)
}

export const _resendOTP = async (payload) => {
  let { _do_call } = HttpCalls;
  let headers = await headersData();
  return _do_call('POST', 'resendOTP', headers, payload)
}

export const _updateOrders = async (payload) => {
  let { _do_call } = HttpCalls;
  let headers = await headersData();
  return _do_call('POST', 'updateOrder', headers, payload)
}

export const _whatsAppShareData = async (payload) => {
  let { _do_call } = HttpCalls;
  let headers = await headersData();
  return _do_call('POST', 'insertOrder', headers, payload)
}

export const _verifyOtp = async (payload) => {
  let { _do_call } = HttpCalls;
  let headers = await headersData();
  return _do_call('POST', 'verifyOtp', headers, payload)
}

export const _cityDevices = async (payload) => {
  let { _do_call } = HttpCalls;
  let headers = await headersData();
  return _do_call('POST', 'locationBrands', headers, payload)
}

export const _allCities = async (payload) => {
  let { _do_call } = HttpCalls;
  let headers = await headersData();
  return _do_call('GET', 'getAllCities', headers, payload)
}

export const _allBrands = async (payload) => {
  let { _do_call } = HttpCalls;
  let headers = await headersData();
  return _do_call('GET', 'getAllbrands', headers, payload)
}

export const _brandModels = async (payload) => {
  let { _do_call } = HttpCalls;
  let headers = await headersData();
  return _do_call('POST', 'getAllModels', headers, payload)
}

export const _modelIssues = async (payload) => {
  let { _do_call } = HttpCalls;
  let headers = await headersData();
  return _do_call('POST', 'getAllissues', headers, payload)
}

export const _searchData = async (payload) => {
  let { _do_call } = HttpCalls;
  let headers = await headersData();
  return _do_call('POST', 'searchData', headers, payload)
}

export const _getTestimonials = async (payload) => {
  let { _do_call } = HttpCalls;
  let headers = await headersData();
  return _do_call('GET', 'testimonials', headers, payload)
}

export const _getAllCoupons = async (payload) => {
  let { _do_call } = HttpCalls;
  let headers = await headersData();
  return _do_call('GET', 'coupons', headers, payload)
}


const headersData = async () => {
  return {
    headers: {
      'Content-Type': 'application/json'
      // 'user_details': cookies.userDetails?JSON.stringify(cookies.userDetails):'',
      // 'token':cookies.token?cookies.token:''
    },
  };
}


export default {
  headersData,
  _getMaxReview,
  _getOTP,
  _resendOTP,
  _updateOrders,
  _whatsAppShareData,
  _verifyOtp,
  _cityDevices,
  _allCities,
  _brandModels,
  _modelIssues,
  _allBrands,
  _searchData,
  _getTestimonials,
  _getAllCoupons
}
